import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconWorkspace = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6zm2 0h6c1.1 0 2-.9 2-2v-7h-8zm8-11V5c0-1.1-.9-2-2-2h-6v7z" />
  </SvgIcon>
);

export default IconWorkspace;



// WEBPACK FOOTER //
// ./src/components/icons/IconWorkspace.js